import { ApprovalRequest } from "@/model/approvalRequest"
import { calcSalesSummary } from "@/parts/Achievement/sales/calcSalesSummary"
import { AchivementSales } from "@/parts/Achievement/sales/types"
import { DateString } from "@/utils/dateString"

export type AchievementSalesByDate = Record<DateString, AchivementSales>

export const calcSalesByDate = ({
    dates,
    reportedApprovalRequestsByDays
}: {
    dates: DateString[]
    reportedApprovalRequestsByDays?: Record<DateString, ApprovalRequest[]>
}): AchievementSalesByDate => {
    const salesByDate: AchievementSalesByDate = {}

    dates.forEach(date => {
        salesByDate[date] = calcSalesSummary({
            reportedApprovalRequests:
                reportedApprovalRequestsByDays?.[date] ?? []
        })
    })

    return salesByDate
}
